import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { InnerSearch } from "../components/search/InnerSearch";
import { RealtedVideo } from "../components/realtedVideo/RealtedVideo";
import { AskedQuestions } from "../help_support/components/AskedQuestions";
import { HelpfulFeedback } from "../components/HelpfulFeedback/HelpfulFeedback";

export const PopularTopicsdetails = () => {
  const { faqID } = useParams();
  const navigate = useNavigate();
  const [faqListData, setFaqListData] = useState([]);
  const { state } = useLocation();
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const fetchIDsUsed = state?.detailsIDs;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [popularTopicsdetailsData, setPopularTopicsdetailsData] = useState([]);

  const PopularTopicsdetails = useCallback(async () => {
    setError("");

    try {
      const payload = {
        ContentCode: fetchIDsUsed?.contentCode || "",
        ContentTypeID: fetchIDsUsed?.contentTypeID || 0,
        CategoryID: 0,
        IsActive: 1,
        PageNumber: 1,
        PageSize: 10,
        SearchValue: fetchIDsUsed?.contentCode || "",
        IsSearch: fetchIDsUsed?.IsSearch || 0,
      };

      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchContentSteps`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      const result = response?.data?.result;
      if (!result || (Array.isArray(result) && result.length === 0)) {
        navigate("/VZYSupport/NoResultsFound");
        return;
      }
      setPopularTopicsdetailsData(response?.data?.result?.contentSteps ?? []);
    } catch (err) {
      setError("Failed to load FAQ details.");
    } finally {
      setLoading(false);
    }
  }, [fetchIDsUsed?.ContentCode]);

  useEffect(() => {
    PopularTopicsdetails();
  }, [PopularTopicsdetails]);

  const PopularTopicsItem = popularTopicsdetailsData?.[0];

  const innerSearch = {
    pageName: "Plans & Subscriptions",
    breadcrumb: [
      {
        label: "Home",
        url: "/VZYSupport/helpSupport",
      },
      { label: "All Popular Topics" },
      { label: fetchIDsUsed?.contentTitle || "Popular Topics details" },
    ],
  };
  const fetchFAQList = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const payload = {
        contentCode: "",
        contentTypeID: 1,
        categoryID: 0,
        isActive: 1,
        pageNumber: 1,
        pageSize: 6,
        searchValue: "",
        CategoryIDs: [],
      };

      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchFAQ`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      const result = response?.data?.result;
      setFaqListData(result?.fAQs ?? []);
    } catch (err) {
      setError("Failed to load FAQs.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFAQList();
  }, [fetchFAQList]);
  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <h4 className="detail-page-title">
                {PopularTopicsItem?.contentTitle}
              </h4>

              <div className="faq-desciption-row">
                {PopularTopicsItem?.contentSteps && (
                  <div
                    className="faq-html-content"
                    dangerouslySetInnerHTML={{
                      __html: PopularTopicsItem.contentSteps,
                    }}
                  />
                )}

                {/* {PopularTopicsItem?.imageAndVideoUrl && (
                  <iframe
                    style={{
                      width: "480px",
                      minHeight: "270px",
                      borderRadius: "8px",
                      marginBottom: "16px",
                    }}
                    src={PopularTopicsItem.imageAndVideoUrl}
                    title={PopularTopicsItem.contentTitle}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                )} */}
              </div>
              <HelpfulFeedback
                title="Was this Answer helpful ?"
                fetchIDsUsed={PopularTopicsItem}
              />

              <h4 className="detail-page-title">Related FAQ’s</h4>
              <div className="faq-accordian">
                {/* <AskedQuestions fetchIDsUsed={PopularTopicsItem} /> */}
                <AskedQuestions faqListData={faqListData} />
              </div>
            </div>

            <div className="col-md-3">
              <h4 className="detail-page-sidebar-title">Related Videos</h4>
              <div className="">
                <RealtedVideo PopularTopicsItem={PopularTopicsItem} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
